import styled from 'styled-components';
import { breakpoints } from '../../styles/theme';
import CheckoutPreOrderTemplate from './CheckoutPreOrderTemplate';
import { rem } from 'polished';

export const CheckoutPreOrderStyled = styled(CheckoutPreOrderTemplate)`
    margin: 0 auto ${rem('40px')};
    width: 100%;

    .dealerSpinner {
        .spinner {
            margin: 0 auto;
            div {
                border-color: ${({ theme }) => theme.colors.grey7} transparent transparent transparent;
            }
        }
    }
    .col {
        width: 100%;
    }

    .subTitle p {
        font-size: ${rem('14px')};
        line-height: ${rem('18px')};
    }

    .consent-checkbox {
        .checkbox-marker {
            min-width: ${rem('22px')};
        }

        .checkbox-content {
            text-align: left;

            p {
                margin: 0;
            }
        }

        .container {
            height: auto;
        }
    }

    .consent-description {
        margin: ${rem(20)} 0;
    }

    .submitButtonInfo {
        font-weight: bold;
        font-size: ${rem('14px')};
        padding: 0 ${rem('7px')};
        line-height: ${rem('20px')};
    }

    .submitButton {
        button {
            white-space: normal;
        }
    }

    @media (min-width: ${breakpoints.lg}px) {
        width: ${rem(1140)};
    }

    .cashPaymentRejectedWrapper {
        background: ${({ theme }) => theme.colors.grey7};
        padding: ${rem(20)} ${rem(10)};
        margin: ${rem(10)} 0;
        font-size: ${({ theme }) => theme.fontSizes.textBase};
        display: flex;
        align-items: center;
        justify-content: space-between;

        &_text {
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
        }

        &_button {
            color: ${({ theme }) => theme.colors.white};
            background: ${({ theme }) => theme.colors.primary};
            text-transform: uppercase;
            cursor: pointer;
            padding: ${rem(10)};
            border: none;
        }
    }
`;
